(() => {
  if (customElements.get('avp-cat-cart-offer')) return;
  class CatCartOffer extends HTMLElement {
    connectedCallback() { queueMicrotask(() => this.init()); }
    init() {
      if (this.ready) return;
      this.ready = true;
      const select = this.querySelector('[data-addon-select]');
      if (select) {
        const config = JSON.parse(this.querySelector('[data-addon-config]').textContent);
        const money = new Intl.NumberFormat(document.documentElement.lang || 'en-US', {style:'currency', currency:config.currency || 'USD'});
        select.addEventListener('change', () => {
          const variant = config.variants.find(v => v.id === select.value);
          if (!variant) return;
          this.querySelector('[data-addon-id]').value = variant.id;
          this.querySelector('[data-addon-price]').textContent = money.format(variant.price / 100);
          const compare = this.querySelector('[data-addon-compare]');
          compare.hidden = variant.compare <= variant.price;
          compare.textContent = money.format(variant.compare / 100);
          this.querySelector('[data-addon-image]').src = variant.image;
        });
      }
      this.querySelector('[data-kit-upgrade]')?.addEventListener('click', () => this.upgrade());
    }
    async upgrade() {
      if (this.pending) return;
      this.pending = true;
      const config = JSON.parse(this.querySelector('[data-upgrade-config]').textContent);
      const drawer = this.closest('cart-drawer');
      const button = this.querySelector('[data-kit-upgrade]');
      const error = this.querySelector('[data-offer-error]');
      const originalText = button.textContent;
      const controls = [...drawer.querySelectorAll('button,input,select')].filter(e => !e.classList.contains('drawer__close'));
      const disabledStates = controls.map(e => [e,e.disabled]);
      controls.forEach(e => e.disabled = true);
      button.textContent = 'Updating your kit…';
      this.setAttribute('aria-busy','true');
      error.hidden = true;
      let base = window.Shopify?.routes?.root || '/';
      if (!base.endsWith('/')) base += '/';
      const post = async (path, body) => {
        const response = await fetch(base + path, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(body)});
        const data = await response.json();
        if (!response.ok || data.status >= 400) throw new Error(data.description || 'We could not update this kit. Please try again.');
        return data;
      };
      const sectionRequest = {sections:drawer.getSectionsToRender().map(s => s.id),sections_url:location.pathname};
      let addedKey = null;
      let sourceRemoved = false;
      try {
        const entries = Array.isArray(config.properties) ? config.properties : Object.entries(config.properties || {});
        const properties = Object.fromEntries(entries.filter(([key]) => !/^\d+$/.test(key)));
        delete properties['First-order gifts'];
        delete properties._avp_cat_gift_tier;
        delete properties._avp_cat_gift_first_order;
        if (config.eligible) {
          const gifts = ['Litter Box Success Checklist'];
          if (config.tier >= 3) gifts.push('The Happy Cat Playbook');
          if (config.tier >= 4) gifts.push('Mystery Gift');
          properties['First-order gifts'] = gifts.join(' · ');
          properties._avp_cat_gift_tier = String(config.tier);
          properties._avp_cat_gift_first_order = 'yes';
        }
        const item = {id:config.targetId,quantity:1,properties};
        if (config.planId) item.selling_plan = String(config.planId);
        const added = await post('cart/add.js',{items:[item]});
        addedKey = (added.items?.[0] || added).key;
        const updated = await post('cart/change.js',{id:config.sourceKey,quantity:0,...sectionRequest});
        sourceRemoved = true;
        drawer.renderContents(updated);
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') publish(PUB_SUB_EVENTS.cartUpdate,{source:'cat-cart-upgrade'});
      } catch (failure) {
        if (addedKey && !sourceRemoved) {
          try {
            const response = await fetch(base + 'cart.js',{headers:{'Accept':'application/json'}});
            if (!response.ok) throw new Error('Cart status unavailable');
            const cart = await response.json();
            if (cart.items.some(item => item.key === config.sourceKey)) {
              await post('cart/change.js',{id:addedKey,quantity:0});
            } else {
              const target = cart.items.find(item => item.key === addedKey);
              if (target) {
                const updated = await post('cart/change.js',{id:addedKey,quantity:target.quantity,...sectionRequest});
                drawer.renderContents(updated);
                return;
              }
            }
          } catch (_) {
            error.textContent = 'The cart may have changed. Refresh and review your kits before checking out.';
            error.hidden = false;
            return;
          }
        }
        error.textContent = failure.message || 'We could not upgrade this kit. Please try again.';
        error.hidden = false;
      } finally {
        disabledStates.forEach(([element,disabled]) => {if(element.isConnected) element.disabled = disabled;});
        if(button.isConnected) button.textContent = originalText;
        this.removeAttribute('aria-busy');
        this.pending = false;
      }
    }
  }
  customElements.define('avp-cat-cart-offer', CatCartOffer);
})();
